<div class="client-info-modal">
  <div class="client-info-modal__header">
    <h2 class="modal-title">Cliente</h2>
    <p class="modal-subtitle">
      Seleccioná el cliente y su domicilio.
    </p>
  </div>

  <form [formGroup]="form" class="client-info-modal__form">

    <!-- CLIENTE -->
    <div class="w-100">
      <label for="clientId" class="client-info-modal__label">Cliente</label>

      <mat-form-field appearance="outline" class="w-100">
        <!-- template ref para evitar casteos en el template -->
        <input id="clientId" #clientInput type="text" matInput placeholder="Buscar cliente..."
          formControlName="clientId" [matAutocomplete]="auto" (input)="onClientSearch(clientInput.value)" />

          <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayClient"
            (optionSelected)="onClientSelected($event.option.value)">
            <!-- el value es el objeto cliente completo -->
            @for (c of filteredClients; track c) {
              <mat-option [value]="c">
                {{ c.name }}
              </mat-option>
            }
          </mat-autocomplete>
        </mat-form-field>
      </div>

      <!-- DOMICILIO -->
      <div class="w-100">
        <label for="addresses" class="client-info-modal__label">Domicilio</label>

        <mat-form-field appearance="outline" class="w-100">
          <!-- formControlName debe coincidir con el FormGroup (addressId) -->
          <mat-select id="addresses" formControlName="addressId">
            @for (a of addresses; track a) {
              <mat-option [value]="a.id">
                {{ formatAddress(a) }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>

    </form>

    <div class="client-info-modal__footer">
      <button mat-button type="button" class="btn btn--outline" (click)="cancel()">
        Cancelar
      </button>

      <button mat-flat-button color="primary" type="button" class="btn btn--primary" (click)="save()">
        Guardar
      </button>
    </div>
  </div>